import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
//import './badge.scss';

class Badge extends Component {

  render() {
    const classes = 'hg-badge';

    const {
      children,
      className
    } = this.props;

    return (
      <div className={classNames(className, classes)}>
        {children}
      </div>
    );
  }
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired
};

export default Badge;



/** WEBPACK FOOTER **
 ** ./client/shared/packages/Badge/src/Badge.jsx
 **/